import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateDividend(state, { id, data }) {
      // 变更状态
      state.fund[id] = data;
    },
  },
  actions: {
    updateDividend({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('FundApi.getFundMNBonusDetail', id)
          .then((json) => {
            commit('updateDividend', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {},
};
